"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAppAuthSelector = void 0;

var _AuthType = require("pricing-pages-unified-ui/constants/AuthType");

var isAppAuthSelector = function isAppAuthSelector(state) {
  return !!(state.config && state.config.authType === _AuthType.APP);
};

exports.isAppAuthSelector = isAppAuthSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ConfigSelectors.js
// module id = 102
// module chunks = 5 6 7